import type { FC, ReactNode } from 'react'

import { Navbar } from '@/components/generals/navbar'
import { Seo } from '@/components/generals/seo'
import { RiffleDeck } from '@/components/riffle/riffle-deck'

// The deck owns the whole viewport and pins itself, so it stands outside the
// standing-page Layout — only the header rides over it.

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />

            <Navbar />

            <RiffleDeck />
        </>
    )
}

export default Home
